import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

import Products from '@/views/product/Products.vue'
import Product from '@/views/product/Product.vue'

import Stock from '@/views/stock/Stock.vue'

import Customers from '@/views/customer/Customers.vue'
import Customer from '@/views/customer/Customer.vue'

import Orders from '@/views/orders/Orders.vue'
import Order from '@/views/orders/Order.vue'



Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                pageTitle: 'Harder',
                breadcrumb: [
                    {
                        text: 'Overblik',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'read',
            },
        },

        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            meta: {
                pageTitle: 'Ordrer',
                breadcrumb: [
                    {
                        text: 'Ordrer',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },
        {
            path: '/orders/:id',
            name: 'order',
            component: Order,
            meta: {
                pageTitle: 'Ordre',
                breadcrumb: [
                    {
                        text: 'Ordrer',
                        to: "/orders",
                        active: false,
                    },
                    {
                        text: 'Ordre',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/customers',
            name: 'customers',
            component: Customers,
            meta: {
                pageTitle: 'Kunder',
                breadcrumb: [
                    {
                        text: 'Kunder',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },
        {
            path: '/customers/:id',
            name: 'customer',
            component: Customer,
            meta: {
                pageTitle: 'Kunde',
                breadcrumb: [
                    {
                        text: 'Kunder',
                        to: "/customers",
                        active: false,
                    },
                    {
                        text: 'Kunde',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/products',
            name: 'products',
            component: Products,
            meta: {
                pageTitle: 'Produkter',
                breadcrumb: [
                    {
                        text: 'Produkter',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },
        {
            path: '/products/:id',
            name: 'product',
            component: Product,
            meta: {
                pageTitle: 'Produkt',
                breadcrumb: [
                    {
                        text: 'Produkter',
                        to: "/products",
                        active: false,
                    },
                    {
                        text: 'Produkt',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/stock',
            name: 'stock',
            component: Stock,
            meta: {
                pageTitle: 'Lager',
                breadcrumb: [
                    {
                        text: 'Lager',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/labels',
            name: 'labels',
            component: () => import('@/views/Labels.vue'),
            meta: {
                pageTitle: 'Etiketter',
                breadcrumb: [
                    {
                        text: 'Etiketter',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/brands',
            name: 'brands',
            component: () => import('@/views/Brands.vue'),
            meta: {
                pageTitle: 'Producenter',
                breadcrumb: [
                    {
                        text: 'Producenter',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },
        {
            path: '/brands/:id',
            name: 'brand',
            component: () => import('@/views/Brand.vue'),
            meta: {
                pageTitle: 'Producenter',
                breadcrumb: [
                    {
                        text: 'Producenter',
                        to: "/brands",
                        active: false,
                    },
                    {
                        text: 'Producent',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/stores',
            name: 'stores',
            component: () => import('@/views/Stores.vue'),
            meta: {
                pageTitle: 'Butikker',
                breadcrumb: [
                    {
                        text: 'Butikker',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },
        {
            path: '/stores/:id',
            name: 'store',
            component: () => import('@/views/Store.vue'),
            meta: {
                pageTitle: 'Butik',
                breadcrumb: [
                    {
                        text: 'Butikker',
                        to: "/stores",
                        active: false,
                    },
                    {
                        text: 'Butik',
                        active: true,
                    },
                ],
                resource: 'Client',
                action: 'manage',
            },
        },

        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/Users.vue'),
            meta: {
                pageTitle: 'Brugere',
                breadcrumb: [
                    {
                        text: 'Brugere',
                        active: true,
                    },
                ],
                resource: 'Admin',
                action: 'manage',
            },
        },
        {
            path: '/users/:id',
            name: 'user',
            component: () => import('@/views/User.vue'),
            meta: {
                pageTitle: 'Bruger',
                breadcrumb: [
                    {
                        text: 'Brugere',
                        to: "/users",
                        active: false,
                    },
                    {
                        text: 'Bruger',
                        active: true,
                    },
                ],
                resource: 'Admin',
                action: 'manage',
            },
        },



        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read',
            },
        },
        {
            path: '/error-404',
            name: 'error-404',
            component: () => import('@/views/error/Error404.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read',
            },
        },
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

import store from '@/store'
import { canNavigate } from '@/libs/acl/routeProtection'

router.beforeEach(async (to, _, next) => {
    store.dispatch("app/UPDATE_PAGETITLE", null)

    if (!store.state.userInit) {
        await store.dispatch("INIT_USER")
    }

    var isLoggedIn = store.state.user

    if (isLoggedIn && !store.state.stores) {
        await store.dispatch("STORES")
    }

    if (!canNavigate(to)) {
        // Redirect to login if not logged in
        // ! We updated login route name here from `auth-login` to `login` in starter-kit
        if (!isLoggedIn) return next({ name: 'login' })

        // If logged in => not authorized
        return next({ name: 'home' })
    }

    // Redirect if logged in
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        return next({ name: 'home' })
    }

    return next()
})

const DEFAULT_TITLE = 'optibase'
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.pageTitle || DEFAULT_TITLE
    })
})


export default router
